<template>
    <v-dialog v-model="dialog" persistent fullscreen
    >
        <video-bg :sources="[require('@/assets/video/login.mp4')]" :img="require('@/assets/video/login.png')" fill-height>
            <v-layout align-center justify-center column fill-height>
                <v-spacer></v-spacer>
                <v-card style="min-width:400px; opacity: 80%">
                    <v-card-title class="accent white--text subheading">
                        <img v-if="brandName=='JEC'" :src="require('@/assets/img/logojec.jpg')" height="50"/>
                        <img v-if="brandName=='Carnot Innovations'" :src="require('@/assets/img/carnotLogo.png')" height="40"/>
                        <span v-if="brandName!=='JEC'">{{brandName}}</span>
                    </v-card-title>
                    <v-card-text v-if="authMode==='main'">
                        <v-text-field
                            v-model="username"
                            :label="'User'|translate"
                            id="username"
                        >
                        </v-text-field>
                        <v-text-field
                            v-model="password"
                            type="password"
                            :label="'Password'|translate"
                            id="password"
                            @keyup.enter="loginProcess"
                        ></v-text-field>
                        <v-card-actions>
                            {{message}} <v-btn block class="primary" @click="loginProcess" id="login">{{'Login'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions v-if="!mobileMode">
                            <v-spacer></v-spacer>
                            <v-btn small flat @click="urlDialog=true" class="grey--text">{{'Set Server URL'|translate}}</v-btn>
                            <set-u-r-l v-model="urlDialog"></set-u-r-l>
                        </v-card-actions>
                    </v-card-text>
                    <v-card-text v-if="authMode==='msal'">
                        <p v-if="!loading&&authOverride">
                            {{'Microsoft authentication anomaly. Please renew login.'|translate}}
                        </p>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&authOverride">
                            <v-btn color="#505050" large @click="$msal.signOut()">{{'Log Out'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="!loading&&!authOverride">
                            <v-btn v-if="!$msal.isAuthenticated()" color="#505050" large @click="$msal.signIn()">{{'Login'|translate}}</v-btn>
                            <v-btn v-else color="#505050" large @click="redirectHome">{{'Back to Home'|translate}}</v-btn>
                        </v-card-actions>
                        <v-card-actions class="justify-center pb-8" v-if="loading">
                            <v-progress-circular :indeterminate="loading" size="50"></v-progress-circular>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
                <v-spacer></v-spacer>
                <div v-if="brandName!=='Carnot Innovations'" style="margin-top: 200px;">
                    <img class="ml-1 grey--text" :src="require('@/assets/img/carnotLogo.png')" height="27"/>
                    <span class="ml-2 mr-5 grey--text" style="padding-top: 0">powered by <strong>Carnot Innovations</strong></span>
                </div>
            </v-layout>
        </video-bg>

    </v-dialog>
</template>

<script>
    import VideoBg from 'vue-videobg'
    import {login, jwtDecode} from '../../helper'
    import { msalMixin } from "vue-msal";
    import SetURL from './setURL'

  export default {
      name: 'LoginDialog',
      components: {SetURL,VideoBg},
      mixins: [msalMixin],
      props: {},
      data() {
          return {
              dialog: false,
              loading:false,
              password: '',
              username: '',
              message: '',
              urlDialog: false,
              authOverride:false,
          }
      },
    watch: {

    },
      computed: {
          mobileMode() {
              return process.env.VUE_APP_MOBILE_MODE ? true : false
          },
          authMode(){
              if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"){
                  return "msal"
              } else {
                  return "main"
              }
          },
          brandName(){
              if (localStorage.getItem('brandingOverride')== '1'){
                  return "Carnot Innovations"
              }
              return process.env.VUE_APP_BRAND_NAME ? process.env.VUE_APP_BRAND_NAME : "Carnot Innovations"
          },
      },
    async mounted () {
        let me = this;
        this.dialog = true
        if (process.env.VUE_APP_EXTERNAL_AUTH && process.env.VUE_APP_EXTERNAL_AUTH === "msal") {
          me.loading = true
          await this.sleep(600)
          if (me.$msal.isAuthenticated()) {
            await this.sleep(600)
            let token = await me.$msal.acquireToken()
            await this.sleep(100)
            if (!token || !token.accessToken) {
              me.authOverride = true
            } else if (me.$route.query.wantedRoute) {
              window.location.href = me.$route.query.wantedRoute
            }
            me.loading = false
          } else {
            me.loading=false
          }
        }
    },
    methods: {
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      },
        redirectHome() {
            this.$router.push({
                name: "home",
            });
        },
      async loginProcess () {
        this.message = 'Login in Progress.'
          let res = await login(this.username, this.password)
          if (res.result=='OK') {
            this.$store.dispatch('setUser', {token: res.token, content: jwtDecode(res.token)})
            localStorage.setItem('pass', res.token)
              if(this.$route.query.wantedRoute){
                  window.location.href=this.$route.query.wantedRoute;
              } else {
                  window.location.href="/";
              }

          } else{
            this.message = 'Login Failed.  Please try again.'
          }
      }
    }
  }
</script>

<style scoped>

</style>
